module.exports = __webpack_public_path__ + "img/petal_1.6ad43743.png";